export default "__VITE_ASSET__tJSePEmt__"